import { render, staticRenderFns } from "./HeatWave.vue?vue&type=template&id=e2a4e0ea"
import script from "./HeatWave.vue?vue&type=script&lang=js"
export * from "./HeatWave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports